import React from "react";
import {
  Plus,
  Trash2,
  ChevronUp,
  ChevronDown,
  Linkedin,
  Facebook,
  Instagram,
  Twitter,
  Github,
  Youtube,
  Globe,
  Link as LinkIcon,
} from "lucide-react";

const LINK_TYPES = [
  { value: "linkedin", label: "LinkedIn", icon: Linkedin },
  { value: "facebook", label: "Facebook", icon: Facebook },
  { value: "x", label: "X (Twitter)", icon: Twitter },
  { value: "instagram", label: "Instagram", icon: Instagram },
  { value: "github", label: "GitHub", icon: Github },
  { value: "youtube", label: "YouTube", icon: Youtube },
  { value: "behance", label: "Behance", icon: Globe },
  { value: "dribbble", label: "Dribbble", icon: Globe },
  { value: "medium", label: "Medium", icon: Globe },
  { value: "gitlab", label: "GitLab", icon: Globe },
  { value: "tiktok", label: "TikTok", icon: Globe },
  { value: "whatsapp", label: "WhatsApp", icon: Globe },
  { value: "telegram", label: "Telegram", icon: Globe },
  { value: "discord", label: "Discord", icon: Globe },
  { value: "website", label: "Personal Website", icon: Globe },
  { value: "other", label: "Other", icon: LinkIcon },
];

const getIcon = (type) => LINK_TYPES.find((t) => t.value === type)?.icon || LinkIcon;

export default function LinksEditor({ links, onChange }) {
  const handleAdd = () => {
    onChange([...(links || []), { type: "linkedin", url: "", label: "" }]);
  };

  const handleRemove = (index) => {
    onChange((links || []).filter((_, i) => i !== index));
  };

  const handleUpdate = (index, field, value) => {
    onChange(
      (links || []).map((link, i) =>
        i === index ? { ...link, [field]: value } : link
      )
    );
  };

  const handleMove = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= (links || []).length) return;
    const newLinks = [...(links || [])];
    [newLinks[index], newLinks[newIndex]] = [newLinks[newIndex], newLinks[index]];
    onChange(newLinks);
  };

  return (
    <div>
      <label className="text-sm font-medium text-gray-700">External Links</label>
      <div className="mt-1 space-y-2">
        {(links || []).map((link, index) => {
          const Icon = getIcon(link.type);
          const total = (links || []).length;
          return (
            <div key={index} className="flex items-center gap-2">
              <div className="flex flex-col">
                <button
                  type="button"
                  onClick={() => handleMove(index, -1)}
                  disabled={index === 0}
                  className="text-gray-400 hover:text-gray-700 disabled:opacity-20 disabled:cursor-not-allowed"
                >
                  <ChevronUp className="w-3.5 h-3.5" />
                </button>
                <button
                  type="button"
                  onClick={() => handleMove(index, 1)}
                  disabled={index === total - 1}
                  className="text-gray-400 hover:text-gray-700 disabled:opacity-20 disabled:cursor-not-allowed"
                >
                  <ChevronDown className="w-3.5 h-3.5" />
                </button>
              </div>
              <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-gray-100 text-gray-500 flex-shrink-0">
                <Icon className="w-4 h-4" />
              </div>
              <select
                value={link.type}
                onChange={(e) => handleUpdate(index, "type", e.target.value)}
                className="px-2 py-2 border border-border rounded-lg focus:ring-2 focus:ring-ring focus:border-transparent bg-card text-foreground text-sm"
              >
                {LINK_TYPES.map((t) => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
              <input
                type="url"
                value={link.url || ""}
                onChange={(e) => handleUpdate(index, "url", e.target.value)}
                placeholder="https://..."
                className="flex-1 min-w-0 px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-ring focus:border-transparent bg-card text-foreground text-sm"
              />
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="p-2 text-gray-400 hover:text-red-600 flex-shrink-0"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          );
        })}
        <button
          type="button"
          onClick={handleAdd}
          className="flex items-center gap-1 px-3 py-1.5 border border-dashed border-gray-300 rounded-lg text-sm text-gray-500 hover:text-blue-600 hover:border-blue-400"
        >
          <Plus className="w-3 h-3" /> Add Link
        </button>
      </div>
    </div>
  );
}